/**
 * Whether a visit belongs to the Offsite Transfers facility.
 *
 * The visit API exposes no visit-level facility/departmentId — only
 * `typeOfCare`, which for an offsite visit is the hospital (department) the
 * patient is transferred to. Every Offsite Transfers department name contains
 * "hospital", so we detect it with a substring match — the same convention used
 * for "ear"/"nurse"/"mental" routing.
 *
 * Note: a plain "Transfer Off Property" disposition (`status === "transferOffProperty"`)
 * does NOT make a visit offsite-styled — like Transfer to JHC, it only reassigns
 * the patient's facility and leaves the transferred visit's own care-type flow
 * (diagnosis, orders, POST discharge) intact. Only visits whose typeOfCare is a
 * hospital department get the listening-ear treatment.
 */
export const isOffsiteTypeOfCare = (typeOfCare?: string): boolean =>
  !!typeOfCare?.toLowerCase()?.includes("hospital");
